import { c as _c } from "react/compiler-runtime";
import { postHostedUserConsentMutation } from '@onefootprint/fetch-hosted';
import type { VerifiedPrefillContext } from '@onefootprint/request-types';
import { Button, Divider, PageShell } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { Trans, useTranslation } from 'react-i18next';
import { getConsentContent } from '@/idv2/components/consent-footer';
import { PoweredByVerified } from '@/idv2/components/powered-by-verified';
type VerifiedPrefillConsentProps = {
  onboardingSessionToken: string;
  verifiedPrefillContext: VerifiedPrefillContext;
  onContinue: () => void;
};
const VerifiedPrefillDisclaimer = t0 => {
  const $ = _c(5);
  const {
    ssn
  } = t0;
  let t1;
  if ($[0] !== ssn) {
    t1 = {
      ssn
    };
    $[0] = ssn;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      linkButton: <a href="https://verified.inc" target="_blank" rel="noopener noreferrer" className="text-accent">{" "}</a>
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <Trans ns="idv2" i18nKey={_temp} values={t1} components={t2} />;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export const VerifiedPrefillConsent = t0 => {
  const $ = _c(30);
  const {
    onboardingSessionToken,
    verifiedPrefillContext,
    onContinue
  } = t0;
  const {
    t
  } = useTranslation("idv2");
  const collectsSsn = verifiedPrefillContext.collectsSsn ?? false;
  let t1;
  if ($[0] !== collectsSsn || $[1] !== t) {
    t1 = getConsentContent(t, [{
      kind: "verified_prefill",
      collectsSsn
    }]);
    $[0] = collectsSsn;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const disclaimerText = t1;
  let t2;
  if ($[3] !== onboardingSessionToken) {
    t2 = postHostedUserConsentMutation({
      headers: {
        "X-Fp-Authorization": onboardingSessionToken
      }
    });
    $[3] = onboardingSessionToken;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const consentMutation = useMutation(t2);
  let t3;
  if ($[5] !== consentMutation || $[6] !== disclaimerText || $[7] !== onContinue) {
    t3 = async () => {
      await consentMutation.mutateAsync({
        body: {
          content: disclaimerText,
          kind: "verified_prefill"
        }
      });
      onContinue();
    };
    $[5] = consentMutation;
    $[6] = disclaimerText;
    $[7] = onContinue;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleContinue = t3;
  let t4;
  if ($[9] !== t) {
    t4 = t(_temp2);
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== collectsSsn || $[12] !== t) {
    t5 = collectsSsn ? t(_temp3) : "";
    $[11] = collectsSsn;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <VerifiedPrefillDisclaimer ssn={t5} />;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = consentMutation.isPending;
  let t8;
  if ($[16] !== t) {
    t8 = t(_temp4);
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== consentMutation.isPending || $[19] !== handleContinue || $[20] !== t8) {
    t9 = <Button type="button" variant="primary" fullWidth={true} size="large" loading={t7} onClick={handleContinue} data-dd-action-name="verified-consent:continue">{t8}</Button>;
    $[18] = consentMutation.isPending;
    $[19] = handleContinue;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Divider />;
    t11 = <PoweredByVerified />;
    $[22] = t10;
    $[23] = t11;
  } else {
    t10 = $[22];
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t9) {
    t12 = <div className="flex flex-col gap-6 w-full">{t9}{t10}{t11}</div>;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t4 || $[28] !== t6) {
    t13 = <PageShell title={t4} subtitle={t6}>{t12}</PageShell>;
    $[26] = t12;
    $[27] = t4;
    $[28] = t6;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
function _temp($) {
  return $.identify.otp.verifiedPrefill.disclaimer;
}
function _temp2($) {
  return $.identify.otp.verifiedPrefill.title;
}
function _temp3($_0) {
  return $_0.identify.otp.verifiedPrefill.ssn;
}
function _temp4($_1) {
  return $_1.identify.email.continue;
}